import styled from "styled-components";
import { AppTheme } from "../../theme";
declare module "styled-components" {
  export interface DefaultTheme extends AppTheme {}
}
export const MSButtonContainer = styled.div`
  padding: 8px 30px;
  background: ${(props) => props.theme.MSBackground};
  border: none;
  box-shadow: ${(props) => props.theme.standardBoxShadow};
  color: ${(props) => props.theme.black};
  font-size: ${(props) => props.theme.fontNormal};
  text-align: center;
  line-height: 12px;
  cursor: pointer;
  white-space: nowrap;
  &:active {
    box-shadow: ${(props) => props.theme.invertedStandardBoxShadow};
  }
`;
